<!-- BEGIN: Subheader -->
<div class="m-subheader ">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">Nuevo Banner</h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a [routerLink]="''" class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a [routerLink]="'/banners'" class="m-nav__link">
                        <span class="m-nav__link-text">Banner</span>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a *ngIf="banner.id == null" [routerLink]="'/banners/create'" class="m-nav__link">
                        <span class="m-nav__link-text">Crear Banner</span>
                    </a>
                    <a *ngIf="banner.id != null" [routerLink]="['/banners/edit', banner.id]" class="m-nav__link">
                        <span class="m-nav__link-text">Editar Banner</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content">
    <div class="row">
        <div class="col-md-12">
            <!--begin::Portlet-->
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 *ngIf="banner.id == null" class="m-portlet__head-text">
                                Crear Banner
                            </h3>
                            <h3 *ngIf="banner.id != null" class="m-portlet__head-text">
                                Editar Banner
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                        <ul class="m-portlet__nav">
                            <li class="m-portlet__nav-item">
                                <a [routerLink]="'/banners'"
                                   class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill  m-dropdown__toggle">
                                    <i class="flaticon-reply"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <form [formGroup]="form" (ngSubmit)="sendForm()" class="m-form m-form--label-align-right">
                    <div class="m-portlet__body">
                        <div class="m-form__section m-form__section--first">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Image principal:</label>
                                <div class="col-lg-6">
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="customFile"
                                               accept="image/x-png,image/jpg,image/jpeg"
                                               (change)="onSelectMainPhoto($event)"
                                               [ngClass]="{ 'is-invalid': submitted && f.main_image.errors }">
                                        <label class="custom-file-label" for="customFile">{{pathFile}}</label>
                                        <div *ngIf="submitted && f.main_image.errors" class="invalid-feedback">
                                            <div *ngIf="f.main_image.errors.required">Campo obligatorio</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Image Móvil:</label>
                                <div class="col-lg-6">
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="customMobile"
                                               accept="image/x-png,image/jpg,image/jpeg"
                                               (change)="onSelectMobilePhoto($event)">
                                        <label class="custom-file-label" for="customMobile">{{pathFile3}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Texto principal:</label>
                                <div class="col-lg-6">
                                    <ckeditor formControlName="main_text" [editor]="Editor"
                                              [config]="configEditor"></ckeditor>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">¿Activar botón de link?:</label>
                                <div *ngIf="status_button==0" class="col-lg-6 d-flex align-items-center">
                                    <label class="m-0 pr-4">
                                        <input type="radio" name="options"  (click)="onSelectRadio($event)" value="1">
                                        Si
                                    </label>
                                    <label class="m-0">
                                        <input type="radio" name="options" (click)="onSelectRadio($event)" value="0" checked>
                                        No
                                    </label>
                                </div>
                                <div *ngIf="status_button==1" class="col-lg-6 d-flex align-items-center">
                                    <label class="m-0 pr-4">
                                        <input type="radio" name="options"  (click)="onSelectRadio($event)" value="1" checked>
                                        Si
                                    </label>
                                    <label class="m-0">
                                        <input type="radio" name="options" (click)="onSelectRadio($event)" value="0">
                                        No
                                    </label>
                                </div>
                            </div>
                            <div *ngIf="status_button == 1">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Image secundaria:</label>
                                    <div class="col-lg-6">
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" id="customSecundary"
                                                   accept="image/x-png,image/jpg,image/jpeg"
                                                   (change)="onSelectSecundaryPhoto($event)">
                                            <label class="custom-file-label" for="customSecundary">{{pathFile2}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Texto botón:</label>
                                    <div class="col-lg-6">
                                        <input formControlName="button_text" class="form-control m-input" placeholder="Texto botón">
                                    </div>
                                </div>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Link botón:</label>
                                    <div class="col-lg-6">
                                        <input formControlName="link_text" class="form-control m-input" placeholder="Link botón">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Estado:</label>
                                <div class="col-lg-6">
                                    <select class="form-control m-input" formControlName="status">
                                        <option value="0">Inactivo</option>
                                        <option value="1">Activo</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot m-portlet__foot--fit">
                        <div class="m-form__actions">
                            <div class="row">
                                <div class="col-2">
                                </div>
                                <div class="col-7">
                                    <button type="submit" [disabled]="loading"
                                            class="btn btn-accent m-btn m-btn--air m-btn--custom"
                                            [ngClass]="{'m-loader m-loader--light m-loader--right': loading}">
                                        Guardar Cambios
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
